import { Col, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import Loader from "../../SharedComponents/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import classes from "../Modal.module.css";
import CommonButton from "../../Components/Buttons/CommonButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import Commonselectfield from "../../Components/CommonForms/CommonSelectField";
import {
  AvoidSpace,
  CatchMessage,
  Float_Valildation,
  JSONtoformdata,
  TrimStart,
} from "../../Shared/Methods";
import Commontextarea from "../../Components/CommonForms/CommonTextArea";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { CreateDeviceAlertSettings } from "../../Services/ApiServices";
import { toast } from "react-toastify";
import { ThersholdOptions, lengths } from "../../Shared/Constants";
import CommonInputTwo from "../../Components/CommonForms/CommonInputTwo";
import Commonradiobutton from "../../Components/CommonForms/CommonRadioButton";
import Commonformerror from "../../Components/CommonForms/CommonFormError";

const validation = Yup.object().shape({
  isthersholdhigh: Yup.boolean(),
  isthersholdlow: Yup.boolean(),

  thershold_high: Yup.string().when("isthersholdhigh", {
    is: (isthersholdhigh: boolean) => isthersholdhigh,
    then: () => Yup.string().required("High is required"),
  }),

  thershold_low: Yup.string().when("isthersholdlow", {
    is: (isthersholdlow: boolean) => isthersholdlow,
    then: () => Yup.string().required("Low is required"),
  }),

  pin_id: Yup.string().required("Input Pin is required"),
  thershold_type: Yup.string().required("thershold Type is required"),
});

interface formikprops {
  pin_id: any;
  thershold_high: string;
  thershold_low: string;
  description: string;
  thershold_type: string;
  isthersholdhigh: boolean;
  isthersholdlow: boolean;
}

function Createdeviceinputpin({
  closable,
  open,
  onCancel,
  handleSuccess,
  DropDowns,
  item,
  Dropdown,
}: {
  closable: boolean;
  open: boolean;
  onCancel: () => void;
  handleSuccess: () => void;
  DropDowns: any;
  item: any;
  Dropdown: any;
}) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const [AlertValues, setAlertValues] = useState<any>([]);
  const dispatch = useDispatch();

  const { InputPin, isInputLoading } = DropDowns || {};
  const { getInputPinDropDown } = Dropdown || {};

  const {
    values,
    handleChange,
    handleSubmit,
    touched,
    errors,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: {
      pin_id: null,
      thershold_high: "1",
      thershold_low: "",
      description: "",
      thershold_type: "",
      isthersholdhigh: true,
      isthersholdlow: true,
    },
    validationSchema: validation,
    onSubmit: () => {
      HandleCreateMeter();
    },
  });

  useEffect(() => {
    getInputPinDropDown();
    setValues({
      ...values,
      thershold_type: "1",
      isthersholdhigh: true,
      isthersholdlow: false,
    });
  }, []);

  const HandleCreateMeter = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
      device_id: item?.deviceId,
      for_type: 3,
      pin_number: InputPin?.find((ele: any) => ele?.id === values?.pin_id)
        .pin_number,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.isthersholdhigh;
    delete finalData?.isthersholdlow;
    delete finalData?.thershold_type;

    CreateDeviceAlertSettings(JSONtoformdata(finalData))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess();
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />
      <Modal open={open} closable={closable} width={900} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>Create Input Pin</h4>

          <Row gutter={[16, 16]} className="mb-4">
            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Input Pin"
                value={values.pin_id}
                onChange={(e) => {
                  setValues({ ...values, pin_id: e });
                }}
                style={{ width: "100%" }}
                options={InputPin?.map((ele: any) => {
                  return {
                    label: ele?.pin_name,
                    value: ele?.id,
                    name: ele?.pin_number,
                  };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={true}
                name="pin_id"
                disabled={isInputLoading}
                loading={isInputLoading}
              />
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="mb-4">
            <Col md={8} sm={12} xs={24}>
              <Commonradiobutton
                options={ThersholdOptions}
                onChange={(e: any) => {
                  setValues({
                    ...values,
                    thershold_type: e.target.value,
                    thershold_high:
                      e.target.value === "1" || e.target.value === "3"
                        ? "1"
                        : "",

                    thershold_low:
                      e.target.value === "2" || e.target.value === "3"
                        ? "1"
                        : "",
                    isthersholdhigh:
                      e.target.value === "1" || e.target.value === "3"
                        ? true
                        : false,
                    isthersholdlow:
                      e.target.value === "2" || e.target.value === "3"
                        ? true
                        : false,
                  });
                }}
                value={values.thershold_type}
                error={errors}
                touched={touched}
                required={true}
                labelname="Thershold"
                name="thershold_type"
                className="mb-3"
              />
              <Commonformerror
                required={true}
                touched={touched}
                name="thershold_type"
                error={errors}
              />
            </Col>
            {/* {values?.thershold_type == "1" || values?.thershold_type == "3" ? (
              <Col md={8} sm={12} xs={24}>
                <CommonInputTwo
                  name="thershold_high"
                  value={values.thershold_high}
                  onChange={(e) => {
                    if (Float_Valildation(e.target)) {
                      setFieldValue("thershold_high", e.target.value);
                    }
                  }}
                  error={errors}
                  touched={touched}
                  required={true}
                  labelname="High"
                  maxLength={lengths.threshold}
                  onKeyDown={AvoidSpace}
                />
              </Col>
            ) : null}

            {values?.thershold_type == "2" || values?.thershold_type == "3" ? (
              <Col md={8} sm={12} xs={24}>
                <CommonInputTwo
                  name="thershold_low"
                  value={values.thershold_low}
                  onChange={(e) => {
                    if (Float_Valildation(e.target)) {
                      setFieldValue("thershold_low", e.target.value);
                    }
                  }}
                  error={errors}
                  touched={touched}
                  required={true}
                  labelname="Low"
                  maxLength={lengths.threshold}
                  onKeyDown={AvoidSpace}
                />  
              </Col>
            ) : null} */}
          </Row>

          <Row gutter={[16, 16]} className="mb-3">
            <Col md={16} sm={12} xs={24}>
              <Commontextarea
                name="description"
                value={values.description}
                onChange={(e: any) => {
                  setFieldValue("description", TrimStart(e.target.value));
                }}
                labelname="Description"
                maxLength={lengths?.Description}
              />
            </Col>
          </Row>

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={handleSubmit}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              // style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Createdeviceinputpin;
